import React from "react";
import { withTranslation } from "react-i18next";
import { LocalStorageService, ContractService, CompanyService, ContractorService, CategoryService, QuestionnaireService } from "../../../services";
import QuestionnairesAdministrationView from "../../views/questionnaires-administration/questionnaires-administration.view";
import { NIL as NIL_UUID } from 'uuid';


class QuestionnairesAdministrationAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      token: "",
      user: {},
      questionnairesByUser: [],
      companysForUser: [],
      showLoadingRequesting: false,
      showErrorRequesting: false,
      showCompletedRequesting: false,
      companySelectQuestionnaires: '',
      filterStatusQuestionnaires: NIL_UUID,
      personTypes: [],
      standardContract: false,
      userCompanies: [{ companyName: this.props.t("questionnairesAssignCategories.no.assign"), id: NIL_UUID }],
      categories: [{ id: 0, name: this.props.t("questionnairesAssignCategories.no.assign") }],
      subCategories: [{ items: [], subcategory: {} }],
      typeDocuments: [],
      permission: {}
    };
  }

  token = {};
  user = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  contractService = new ContractService(this.url);
  companyService = new CompanyService(this.url);
  contractorService = new ContractorService(this.url)
  categoryService = new CategoryService(this.url);
  questionnaireService = new QuestionnaireService(process.env.REACT_APP_MIFIRMA_API);

  async componentDidMount() {
    let { state } = this.props.location
    let standardContract
    if (state && state.standardContract) standardContract = true
    this.setState({ loading: true });
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    let user = this.localStorageService.getLocalStorageItem("user");
    this.user = user

    try {
      this.setState({
        user,
        token: this.token,
        standardContract
      });
    } catch (error) {
      this.props.history.push("/");
      this.props.setShowError(true);
      return;
    }

    if (user) {
      let userId = user.userMetaData.userA3Cloud.clientId;
      let questionnairesByUser =
        await this.contractService.getQuestionnairesByUserId(
          this.token,
          userId
        );
      let companysClient = await this.companyService.getCompanys(this.token)
      let allCompanys = []

      for (let i = 0; i < companysClient.data.data.length; i++) {
        if (companysClient.data.data[i].company.companyName !== null && companysClient.data.data[i].company.companyName !== '' && companysClient.data.data[i].company.id !== null && companysClient.data.data[i].company.id !== '' && companysClient.data.data[i].company.status === true) {
          let info = {}
          info = {
            id: companysClient.data.data[i].company.id,
            companyName: companysClient.data.data[i].company.companyName
          }
          allCompanys.push(info)
        }
      }
      allCompanys = allCompanys.sort((a, b) => a.companyName.toLowerCase().localeCompare(b.companyName.toLowerCase()));

      let noAssign = {
        companyName: this.props.t("questionnairesAssignCategories.no.assign"),
        id: NIL_UUID
      }

      allCompanys.unshift(noAssign)

      this.setState({
        loading: false,
        questionnairesByUser: questionnairesByUser.data.data,
        companysForUser: allCompanys
      });

      await this.getTypeDocuments();
    }

  }

  toggleErrorRequesting = (value) => {
    this.setState({
      showErrorRequesting: value
    }, () => {
      setTimeout(() => {
        this.setState({ showErrorRequesting: false })
      }, 2000)
    })
  }

  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  toggleCompletedRequesting = (value, message, questionnaires) => {
    this.setState(
      {
        showCompletedRequesting: value,
        message: message
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCompletedRequesting: false,
            message: '',
            questionnairesByUser: questionnaires || [],
          });
          // funcion()
        }, 4000);
      }
    );
  };

  toggleCompletedQuestionsRequesting = (value) => {
    this.setState({
      showCompletedRequesting: value,
    });
  }

  changeRedirect = (value) => {
    this.setState({
      standardContract: value
    })
  }

  forceRefresh = () => {
    this.setState(({ shouldRefresh }) => ({ shouldRefresh: !shouldRefresh }));
  };

  setCompanySelectQuestionnaires = (value) => {
    this.setState({
      companySelectQuestionnaires: value
    })
  }

  setFilterStatusQuestionnaires = (value) => {
    this.setState({
      filterStatusQuestionnaires: value
    })
  }
  //get persontypes
  getContractPersonTypes = async () => {
    try {
      let contractorPersonType = await this.contractorService.getPersonTypeByKey('documentType', this.token)
      if (contractorPersonType && contractorPersonType.data && Number(contractorPersonType.statusCode) === 200) {
        let personTypes = contractorPersonType.data.filter((type) => type.id === Number(process.env.REACT_APP_PERSON_TYPE_CONTRACTOR_MORAL_ID) || type.id === Number(process.env.REACT_APP_PERSON_TYPE_CONTRACTOR_PHYSICAL_ID))
        this.setState({
          personTypes
        })
      } else {
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true)
        setTimeout(() => {
          this.toggleErrorRequesting(true)
          this.props.history.push("/")
        }, 4000)
      }
    } catch (error) {
      console.log(error)
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(true)
      setTimeout(() => {
        this.toggleErrorRequesting(true)
        this.props.history.push("/")
      }, 4000)
    }
  }

  getTypeDocuments = async () => {
    try {
      let typeDocumentsBD = await this.categoryService.getTypeDocuments(this.token, 'Documento');
      if (typeDocumentsBD && typeDocumentsBD.data && Number(typeDocumentsBD.statusCode) === 200) {
        let typeDocuments = typeDocumentsBD.data;
        typeDocuments.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
        this.setState({
          typeDocuments
        })
      } else {
        this.setState({ message: this.props.t("signatureRequestProfileAction.error.typedocuments") })
        await this.toggleLoadingRequesting(false)
        await this.toggleErrorRequesting(true)
        return false
      }
    } catch (error) {
      this.setState({ message: this.props.t("signatureRequestProfileAction.error.typedocuments") })
      await this.toggleLoadingRequesting(false)
      await this.toggleErrorRequesting(true)
      return false
    }
  }

  getUserCompanies = async () => {
    this.toggleLoadingRequesting(true)
    try {
      let companiesBD = await this.companyService.getUsersCompanies(this.token)
      if (companiesBD && companiesBD.data && Number(companiesBD.statusCode) === 200) {
        let companies = companiesBD.data.map(company => ({
          id: company.company.id,
          companyName: company.company.companyName,
        }))
        companies = companies.sort((a, b) => a.companyName.toLowerCase().localeCompare(b.companyName.toLowerCase()));
        let noAssign = {
          companyName: this.props.t("questionnairesAssignCategories.no.assign"),
          id: NIL_UUID
        }
        companies.unshift(noAssign)
        this.setState({
          userCompanies: companies,
          categories: [{ id: 0, name: this.props.t("questionnairesAssignCategories.no.assign") }],
          subCategories: [{ items: [], subcategory: {} }]
        })

        this.toggleLoadingRequesting(false)
      } else {
        this.setState({ message: this.props.t("signatureRequestProfileAction.error.companies") })
        await this.toggleLoadingRequesting(false)
        await this.toggleErrorRequesting(true)
        return false
      }
    } catch (error) {
      this.setState({ message: this.props.t("signatureRequestProfileAction.error.companies") })
      await this.toggleLoadingRequesting(false)
      await this.toggleErrorRequesting(true)
      return false
    }
  }

  getUserCategories = async (companyId, setCategoryId, setSelect) => {
    if (companyId === NIL_UUID) {
      this.setState({ categories: [], subCategories: [] })
      setCategoryId(0)
      setSelect([''])
      return
    }

    this.toggleLoadingRequesting(true);
    try {

      let categoriesBD = await this.categoryService.getAllCategoriesByCompanyId({
        companyId: companyId,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        token: this.token
      });

      if (categoriesBD && categoriesBD.data && Number(categoriesBD.statusCode) === 200) {
        let categories = categoriesBD.data.fileData || []
        let permission = categoriesBD.data.permission || {}

        this.setState({
          categories: categories || [],
          subCategories: categories || [],
          permission: permission
        })

        setCategoryId(0)
        setSelect([''])
        this.toggleLoadingRequesting(false)
        return categoriesBD
      } else {
        this.setState({ message: this.props.t('signatureRequestProfileAction.error.categories') })
        await this.toggleLoadingRequesting(false)
        await this.toggleErrorRequesting(true)
        return false
      }
    } catch (error) {
      this.setState({ message: this.props.t('signatureRequestProfileAction.error.categories') })
      await this.toggleLoadingRequesting(false)
      await this.toggleErrorRequesting(true)
      return false
    }
  }


  handleAssignCategories = async (data, hideShowDetails) => {
    this.toggleLoadingRequesting(true)
    try {
      let { solicitudeId, companyId, categoryId, subCategoryId, typeDocument, pathBreadcrumb } = data
      let classifier = await this.questionnaireService.createOrUpdateClassifier(solicitudeId, companyId, categoryId, subCategoryId, typeDocument, pathBreadcrumb, this.token)
      if (classifier && classifier.data && Number(classifier.statusCode) === 200) {
        let userId = this.user.userMetaData.userA3Cloud.clientId;
        let questionnaires = await this.contractService.getQuestionnairesByUserId(this.token, userId);
        this.toggleLoadingRequesting(false)
        this.toggleCompletedRequesting(true, "", questionnaires.data.data);
        setTimeout(() => {
          hideShowDetails()
        }, 4000)
      } else {
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true)
      }
    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(true)
    }
  }

  setDigitalVaultCategory = async (
    selectedQuestionnaire,
    setCompanyId,
    setTypeDocument,
    setCategoryId,
    setSelect,
    setExpand,
    isInitial = false
  ) => {
    // ⚙️ Solo mostrar loading si es inicial
    if (isInitial) this.toggleLoadingRequesting(true)

    try {
      let companies = this.state.userCompanies
      let typeDocuments = this.state.typeDocuments

      // 🧠 Si todavía no se han cargado en memoria, los trae
      if (companies.length <= 1) {
        const companiesBD = await this.companyService.getUsersCompanies(this.token)
        if (companiesBD && Number(companiesBD.statusCode) === 200) {
          companies = companiesBD.data.map(c => ({
            id: c.company.id,
            companyName: c.company.companyName
          }))
          companies.sort((a, b) => a.companyName.localeCompare(b.companyName))
          companies.unshift({ companyName: this.props.t("questionnairesAssignCategories.no.assign"), id: NIL_UUID })
          this.setState({ userCompanies: companies })
        }
      }

      if (typeDocuments.length === 0) {
        const typeDocsBD = await this.categoryService.getTypeDocuments(this.token, 'Documento')
        if (typeDocsBD && Number(typeDocsBD.statusCode) === 200) {
          typeDocuments = typeDocsBD.data.sort((a, b) => a.name.localeCompare(b.name))
          this.setState({ typeDocuments })
        }
      }

      // 🧩 Si el cuestionario ya tiene asignación, solo traer categorías

      const classifier = selectedQuestionnaire?.classifier
      const companyDisabled = !!(classifier?.companyId && classifier.companyId !== NIL_UUID);
      this.setState({ companyDisable: companyDisabled });
      if (classifier?.companyId && classifier?.subCategoryId) {
        const categoriesBD = await this.categoryService.getAllCategoriesByCompanyId({
          companyId: classifier.companyId,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          token: this.token
        })
        if (categoriesBD && Number(categoriesBD.statusCode) === 200) {
          const cats = categoriesBD.data.fileData || []
          this.setState({ subCategories: cats, categories: cats })
        }
      }

      // 🔹 Setear valores en los hooks
      setCompanyId(classifier?.companyId || NIL_UUID)
      setTypeDocument(
        typeDocuments.find(td => td.id === classifier?.typeDocumentId) || ''
      )
      setCategoryId(classifier?.categoryId || 0)
      setSelect([''])

    } catch (error) {
      console.error('Error en setDigitalVaultCategory:', error)
    } finally {
      if (isInitial) this.toggleLoadingRequesting(false)
    }
  }


  createSubcategory = async ({ categoryName, companyId, parentId }) => {
    try {
      const level = 2
      const response = await this.categoryService.createNewCategory(
        categoryName,
        null,
        null,
        null,
        'Custom',
        companyId,
        'Sub',
        level,
        parentId,
        false,
        this.token
      )

      if (response && response.data && response.statusCode === 200) {
        return response.data
      } else {
        return null
      }
    } catch (error) {
      console.error(error)
      return null
    }
  }

  refreshCategories = async (companyId) => {
    try {
      const response = await this.categoryService.getAllCategoriesByCompanyId({
        companyId,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        token: this.token
      }, true)

      if (response && response.data && Number(response.statusCode) === 200) {
        const categories = response.data.fileData || []
        const permission = response.data.permission || {}
        this.setState({
          subCategories: categories,
          categories: categories,
          permission: permission
        })
        return response
      }
    } catch (err) {
      console.error('Error refreshing categories:', err)
    }
  }

  render() {
    return <QuestionnairesAdministrationView
      {...this.state}
      changeRedirect={this.changeRedirect}
      forceRefresh={this.forceRefresh}
      toggleErrorRequesting={this.toggleErrorRequesting}
      toggleLoadingRequesting={this.toggleLoadingRequesting}
      toggleCompletedRequesting={this.toggleCompletedRequesting}
      toggleCompletedQuestionsRequesting={this.toggleCompletedQuestionsRequesting}
      setCompanySelectQuestionnaires={this.setCompanySelectQuestionnaires}
      setFilterStatusQuestionnaires={this.setFilterStatusQuestionnaires}
      getContractPersonTypes={this.getContractPersonTypes}

      getUserCompanies={this.getUserCompanies}
      getUserCategories={this.getUserCategories}
      getTypeDocuments={this.getTypeDocuments}
      handleAssignCategories={this.handleAssignCategories}
      setDigitalVaultCategory={this.setDigitalVaultCategory}
      createSubcategory={this.createSubcategory}
      refreshCategories={this.refreshCategories}
      changeRoute={this.props.changeRoute}
    />;
  }
}

export default withTranslation()(QuestionnairesAdministrationAction);

